"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _DropdownStateful = _interopRequireDefault(require("./DropdownStateful"));

var _Timezone = _interopRequireDefault(require("../Timezone"));

var _timezones = _interopRequireDefault(require("../Timezone/timezones.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PLACEHOLDER = 'Select a timezone';
var sortedGroups = Object.keys(_timezones.default).sort();

function valueToSelection(value) {
  if (!value) return;
  return _react.default.createElement(_Timezone.default, null, value);
}

var TimezoneDropdown = function TimezoneDropdown(_ref) {
  var id = _ref.id,
      selectedValue = _ref.selectedValue,
      open = _ref.open,
      onChange = _ref.onChange,
      disabled = _ref.disabled;
  return _react.default.createElement(_DropdownStateful.default, {
    id: id,
    searchable: true,
    placeholder: PLACEHOLDER,
    open: open,
    onChange: onChange,
    valueToSelection: valueToSelection,
    disabled: disabled
  }, sortedGroups.map(function (group) {
    var options = _timezones.default[group];
    return _react.default.createElement(_DropdownStateful.default.OptionGroup, {
      key: group,
      title: group
    }, options.map(function (tz) {
      return _react.default.createElement(_DropdownStateful.default.Option, {
        key: tz.value,
        value: tz.value,
        selected: selectedValue === tz.value
      }, tz.displayName);
    }));
  }));
};

TimezoneDropdown.propTypes = {
  id: _propTypes.string,
  open: _propTypes.bool,
  selectedValue: _propTypes.string,
  onChange: _propTypes.func,
  disabled: _propTypes.bool
};
var _default = TimezoneDropdown;
exports.default = _default;
TimezoneDropdown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TimezoneDropdown",
  "props": {
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "open": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "selectedValue": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};